import './index.less'

import PropTypes from 'ant-design-vue/es/_util/vue-types'
import { RouterView } from 'vue-router'
import { layoutContentWidth } from '../../utils/util'

const GridContent = {
  name: 'GridContent',
  functional: true,
  props: {
    children: PropTypes.any,
    contentWidth: PropTypes.oneOf(['Fluid', 'Fixed']).def('Fluid')
  },
  render (h, content) {
    // Vue 3 中函数式组件的 content 结构：{ props, children, data, slots, attrs }
    // 参考 BasicLayout.jsx 的用法：const { props, children } = content
    if (!content) {
      return <div class="ant-pro-grid-content"></div>
    }
    
    // 安全解构，参考 Fragment.jsx
    // Vue 3 函数式组件：content = { props, children, slots, attrs, data }
    const { props: contentProps = {}, children: contentChildren, slots } = content
    const contentWidth = (contentProps && contentProps.contentWidth) || 'Fluid'
    
    // 详细调试信息
    console.log('GridContent: content 完整结构:', {
      hasProps: !!contentProps,
      hasChildren: !!contentChildren,
      childrenType: typeof contentChildren,
      childrenIsArray: Array.isArray(contentChildren),
      childrenLength: Array.isArray(contentChildren) ? contentChildren.length : (contentChildren ? 'not array' : 'null/undefined'),
      hasSlots: !!slots,
      hasSlotsDefault: !!(slots && slots.default),
      contentKeys: Object.keys(content || {}),
      contentChildrenValue: contentChildren,
      slotsDefaultValue: slots && slots.default ? slots.default() : null
    })
    
    // 参考 Fragment.jsx: const children = ctx.children || (ctx.slots && ctx.slots.default && ctx.slots.default()) || []
    // 在 Vue 3 中，JSX 传递的 children 可能在 content.children 中，也可能在 slots.default() 中
    let finalChildren = null
    
    // 首先尝试从 content.children 获取
    if (contentChildren) {
      finalChildren = contentChildren
      console.log('GridContent: 从 content.children 获取:', finalChildren)
    }
    
    // 如果 content.children 为空，尝试从 slots.default() 获取
    if (!finalChildren && slots && slots.default) {
      const slotResult = slots.default()
      if (slotResult) {
        finalChildren = slotResult
        console.log('GridContent: 从 slots.default() 获取:', finalChildren)
      }
    }
    
    // 如果都没有，使用空数组
    if (!finalChildren) {
      finalChildren = []
    }
    
    // 确保是数组
    if (!Array.isArray(finalChildren)) {
      finalChildren = finalChildren ? [finalChildren] : []
    }
    
    // 如果最终没有获取到 children，直接渲染 RouterView 作为备用
    if (finalChildren.length === 0) {
      console.warn('GridContent: 未获取到 children，直接渲染 RouterView 作为备用。')
      finalChildren = [<RouterView />]
    }
    
    console.log('GridContent: 最终 children:', finalChildren.length, '第一个子元素类型:', finalChildren[0]?.type?.name || finalChildren[0]?.type)

    const propsContentWidth = layoutContentWidth(contentWidth)
    const classNames = {
      'ant-pro-grid-content': true,
      'wide': propsContentWidth
    }

    return <div class={classNames}>{finalChildren}</div>
  }
}

export default GridContent
